export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14214.c9deb1b3.jpg";